import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Dialog, Button, RadioButton, Image } from "hesus-ui-kit";
import { useNavigate } from "react-router-dom";
import {
  HeaderWrapper,
  ButtonWrapper,
  FormBody,
  Title,
  OptionsWrapper,
  FlexRow,
  SectionContainer,
  OuterWrapper,
  RowTitleText,
  CenterProductLink,
  InformationBox,
  QuestionText,
  GridRow,
} from "./CopyCenterProduct.styled";

import closeIcon from "@icons/ic-close-white.svg";

const CopyCenterProduct = (props) => {
  const { t, data, onClose, companyId, centerId } = props;

  const [productChoice, setProductChoice] = useState(1);

  const onProductChoiceChange = (e) => {
    setProductChoice(parseInt(e.target.value, 10));
  };

  const history = useNavigate();
  const onValidate = () => {
    history(
      `/company/view/${companyId}/center/${centerId}/product/clone/${data.id}/${productChoice}`
    );
  };

  const onProductViewClick = () => {
    history(
      `/company/view/${companyId}/center/${centerId}/product/view/${data.id}`
    );
  };

  return (
    <Dialog width="45rem">
      <div>
        <HeaderWrapper>
          <Title>{t("COPY_CENTRE_PRODUCT") + " #" + data?.id}</Title>
          <Button
            onClick={onClose}
            styles={{
              backgroundColor: "transparent",
              border: "none",
              height: "auto",
              padding: 0,
              "&:hover": {
                backgroundColor: "transparent",
              },
            }}
          >
            <Image
              src={closeIcon}
              alt="close popup"
              styles={{ width: "auto" }}
            />
          </Button>
        </HeaderWrapper>
        <FormBody>
          <OptionsWrapper>
            <FlexRow>
              <SectionContainer>
                <OuterWrapper>
                  <InformationBox>
                    <RowTitleText>
                      {t("COPY_CENTRE_PRODUCT_TITLE")}
                    </RowTitleText>
                    <CenterProductLink
                      onClick={onProductViewClick}
                      textDecoration="underline"
                    >
                      {data?.product?.name +
                        (data.label ? " - " + data.label : "")}
                    </CenterProductLink>
                  </InformationBox>
                </OuterWrapper>
                <OuterWrapper>
                  <InformationBox>
                    <QuestionText>
                      {" "}
                      {t("COPY_CENTRE_PRODUCT_QUESTION")}
                    </QuestionText>
                  </InformationBox>
                </OuterWrapper>
                <GridRow>
                  <div className="center-products-list__question_choice">
                    <RadioButton
                      value={productChoice}
                      onChange={onProductChoiceChange}
                      name="price-type"
                      options={[
                        {
                          label: t("COPY_CENTRE_PRODUCT_ONLY"),
                          value: 1,
                        },
                        {
                          label: t("COPY_CENTRE_PRODUCT_AND_PRICES"),
                          value: 2,
                        },
                      ]}
                    />
                  </div>
                </GridRow>
              </SectionContainer>
            </FlexRow>
          </OptionsWrapper>
          <ButtonWrapper>
            <Button
              styles={{
                color: "#333",
                background: "#fff",
                border: "1px solid #ccc",
                marginRight: "0.32rem",
                "&:hover": {
                  backgroundColor: "#ccc",
                },
              }}
              onClick={onClose}
            >
              <>{t("CLOSE")}</>
            </Button>
            <Button
              styles={{
                color: "white",
                background: "#1BACE4",
                border: "1px solid #1BACE4",
                marginRight: "0.32rem",
                "&:hover": {
                  backgroundColor: "#1589b6",
                },
              }}
              onClick={onValidate}
            >
              {t("VALIDATE")}
            </Button>
          </ButtonWrapper>
        </FormBody>
      </div>
    </Dialog>
  );
};

CopyCenterProduct.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(CopyCenterProduct);
